module.exports = __webpack_public_path__ + "static/media/forgotPasswordLogo.cf929b2b.png";